import { assoc } from 'ramda'
import { useMemo } from 'react'

import { useActionPlansReplies } from './actionPlansReplies'

export const useActionPlans = () => {
  const replies = useActionPlansReplies()

  return useMemo(
    () =>
      replies.reduce((actionPlans, reply) => {
        return [...actionPlans, ...reply.value.map(assoc('reply', reply))]
      }, []),
    [replies]
  )
}
